module.exports = __webpack_public_path__ + "img/img_level_5.2f3fc846.png";